import { render, staticRenderFns } from "./itsm.vue?vue&type=template&id=3b264547&"
import script from "./itsm.vue?vue&type=script&lang=js&"
export * from "./itsm.vue?vue&type=script&lang=js&"
import style0 from "./itsm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports